module.exports = __webpack_public_path__ + "img/analytical.bdc5a84c.png";